import { useEffect } from 'react';
import { rage } from '~/rage';

const INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];

const useInputActive = (): void => {
	useEffect(() => {
		const handleFocusIn = (e: FocusEvent) => {
			if (INPUT_TAGS.includes((e.target as HTMLElement).tagName)) {
				rage.input
					.setAnyInputFocused(true)
					.catch((err) => rage.notifications.showException(err));
			}
		};

		const handleFocusOut = (e: FocusEvent) => {
			if (INPUT_TAGS.includes((e.target as HTMLElement).tagName)) {
				if (
					!e.relatedTarget ||
					!INPUT_TAGS.includes((e.relatedTarget as HTMLElement).tagName)
				) {
					rage.input
						.setAnyInputFocused(false)
						.catch((err) => rage.notifications.showException(err));
				}
			}
		};

		document.addEventListener('focusin', handleFocusIn);
		document.addEventListener('focusout', handleFocusOut);

		return () => {
			document.removeEventListener('focusin', handleFocusIn);
			document.removeEventListener('focusout', handleFocusOut);
		};
	}, []);
};

export { useInputActive };
